interface MainContentProps {
  children: React.ReactNode;
}

export default function MainContent({ children }: MainContentProps) {
  return (
    <div className="container lg:max-w-7xl mx-auto my-10">
      <main>{children}</main>
    </div>
  );
}
